export function scoreColor(v) {
  if (v >= 80) return "#10B981";
  if (v >= 60) return "#06B6D4";
  if (v >= 40) return "#F59E0B";
  return "#EF4444";
}

export function RadialScore({ value, size = 96, label, stroke = 8, testId }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const color = scoreColor(value);
  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r} stroke={color} strokeWidth={stroke} fill="none"
          strokeLinecap="round" strokeDasharray={c}
          strokeDashoffset={c - (value / 100) * c}
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono font-bold text-xl" style={{ color }}>{value}</span>
        {label && <span className="text-[10px] uppercase tracking-widest text-slate-500">{label}</span>}
      </div>
    </div>
  );
}

export function BarScore({ label, value, invert = false, testId }) {
  const display = value;
  const color = scoreColor(invert ? 100 - value : value);
  return (
    <div data-testid={testId}>
      <div className="flex justify-between items-baseline mb-1">
        <span className="text-xs text-slate-400">{label}</span>
        <span className="font-mono text-sm font-bold" style={{ color }}>{display}</span>
      </div>
      <div className="h-1.5 rounded-full bg-white/8 overflow-hidden">
        <div className="h-full rounded-full" style={{ width: `${value}%`, background: color, transition: "width 0.9s cubic-bezier(0.22,1,0.36,1)" }} />
      </div>
    </div>
  );
}
